import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { AUDIO_NODE_STORE, EVENT_LISTENERS } from '../globals';
import { isAudioNode } from '../guards/audio-node';
import { isAudioNodeOutputConnection } from '../guards/audio-node-output-connection';
import { addActiveInputConnectionToAudioParam } from '../helpers/add-active-input-connection-to-audio-param';
import { addPassiveInputConnectionToAudioParam } from '../helpers/add-passive-input-connection-to-audio-param';
import { connectNativeAudioNodeToNativeAudioNode } from '../helpers/connect-native-audio-node-to-native-audio-node';
import { deleteActiveInputConnection } from '../helpers/delete-active-input-connection';
import { deleteActiveInputConnectionToAudioParam } from '../helpers/delete-active-input-connection-to-audio-param';
import { deleteEventListenerOfAudioNode } from '../helpers/delete-event-listeners-of-audio-node';
import { deletePassiveInputConnectionToAudioNode } from '../helpers/delete-passive-input-connection-to-audio-node';
import { deletePassiveInputConnectionToAudioParam } from '../helpers/delete-passive-input-connection-to-audio-param';
import { disconnectNativeAudioNodeFromNativeAudioNode } from '../helpers/disconnect-native-audio-node-from-native-audio-node';
import { getAudioNodeConnections } from '../helpers/get-audio-node-connections';
import { getAudioParamConnections } from '../helpers/get-audio-param-connections';
import { getEventListenersOfAudioNode } from '../helpers/get-event-listeners-of-audio-node';
import { getNativeAudioNode } from '../helpers/get-native-audio-node';
import { getNativeAudioParam } from '../helpers/get-native-audio-param';
import { insertElementInSet } from '../helpers/insert-element-in-set';
import { isActiveAudioNode } from '../helpers/is-active-audio-node';
import { isPartOfACycle } from '../helpers/is-part-of-a-cycle';
import { isPassiveAudioNode } from '../helpers/is-passive-audio-node';
import { setInternalStateToActive } from '../helpers/set-internal-state-to-active';
import { setInternalStateToPassiveWhenNecessary } from '../helpers/set-internal-state-to-passive-when-necessary';
import { testAudioNodeDisconnectMethodSupport } from '../helpers/test-audio-node-disconnect-method-support';
import { visitEachAudioNodeOnce } from '../helpers/visit-each-audio-node-once';
import { wrapAudioNodeDisconnectMethod } from '../helpers/wrap-audio-node-disconnect-method';

var addConnectionToAudioParamOfAudioContext = function addConnectionToAudioParamOfAudioContext(source, destination, output, isOffline) {
  var _getAudioParamConnect = getAudioParamConnections(destination),
      activeInputs = _getAudioParamConnect.activeInputs,
      passiveInputs = _getAudioParamConnect.passiveInputs;

  var _getAudioNodeConnecti = getAudioNodeConnections(source),
      outputs = _getAudioNodeConnecti.outputs;

  var eventListeners = getEventListenersOfAudioNode(source);

  var eventListener = function eventListener(isActive) {
    var nativeAudioNode = getNativeAudioNode(source);
    var nativeAudioParam = getNativeAudioParam(destination);

    if (isActive) {
      var partialConnection = deletePassiveInputConnectionToAudioParam(passiveInputs, source, output);
      addActiveInputConnectionToAudioParam(activeInputs, source, partialConnection, false);

      if (!isOffline && !isPartOfACycle(source)) {
        nativeAudioNode.connect(nativeAudioParam, output);
      }
    } else {
      var _partialConnection = deleteActiveInputConnectionToAudioParam(activeInputs, source, output);

      addPassiveInputConnectionToAudioParam(passiveInputs, _partialConnection, false);

      if (!isOffline && !isPartOfACycle(source)) {
        nativeAudioNode.disconnect(nativeAudioParam, output);
      }
    }
  };

  if (insertElementInSet(outputs, [destination, output], function (outputConnection) {
    return outputConnection[0] === destination && outputConnection[1] === output;
  }, true)) {
    eventListeners.add(eventListener);

    if (isActiveAudioNode(source)) {
      addActiveInputConnectionToAudioParam(activeInputs, source, [output, eventListener], true);
    } else {
      addPassiveInputConnectionToAudioParam(passiveInputs, [source, output, eventListener], true);
    }

    return true;
  }

  return false;
};

var deleteInputConnectionOfAudioNode = function deleteInputConnectionOfAudioNode(source, destination, output, input) {
  var _getAudioNodeConnecti2 = getAudioNodeConnections(destination),
      activeInputs = _getAudioNodeConnecti2.activeInputs,
      passiveInputs = _getAudioNodeConnecti2.passiveInputs;

  var activeInputConnection = deleteActiveInputConnection(activeInputs[input], source, output);

  if (activeInputConnection === null) {
    var passiveInputConnection = deletePassiveInputConnectionToAudioNode(passiveInputs, source, output, input);
    return [passiveInputConnection[2], false];
  }

  return [activeInputConnection[2], true];
};

var deleteInputConnectionOfAudioParam = function deleteInputConnectionOfAudioParam(source, destination, output) {
  var _getAudioParamConnect2 = getAudioParamConnections(destination),
      activeInputs = _getAudioParamConnect2.activeInputs,
      passiveInputs = _getAudioParamConnect2.passiveInputs;

  var activeInputConnection = deleteActiveInputConnection(activeInputs, source, output);

  if (activeInputConnection === null) {
    var passiveInputConnection = deletePassiveInputConnectionToAudioParam(passiveInputs, source, output);
    return [passiveInputConnection[1], false];
  }

  return [activeInputConnection[2], true];
};

var deleteInputsOfAudioNode = function deleteInputsOfAudioNode(source, isOffline, destination, output, input) {
  var _deleteInputConnectio = deleteInputConnectionOfAudioNode(source, destination, output, input),
      _deleteInputConnectio2 = _slicedToArray(_deleteInputConnectio, 2),
      listener = _deleteInputConnectio2[0],
      isActive = _deleteInputConnectio2[1];

  if (listener !== null) {
    deleteEventListenerOfAudioNode(source, listener);

    if (isActive && !isOffline && !isPartOfACycle(source)) {
      disconnectNativeAudioNodeFromNativeAudioNode(getNativeAudioNode(source), getNativeAudioNode(destination), output, input);
    }
  }

  if (isActiveAudioNode(destination)) {
    var _getAudioNodeConnecti3 = getAudioNodeConnections(destination),
        activeInputs = _getAudioNodeConnecti3.activeInputs;

    setInternalStateToPassiveWhenNecessary(destination, activeInputs);
  }
};

var deleteInputsOfAudioParam = function deleteInputsOfAudioParam(source, isOffline, destination, output) {
  var _deleteInputConnectio3 = deleteInputConnectionOfAudioParam(source, destination, output),
      _deleteInputConnectio4 = _slicedToArray(_deleteInputConnectio3, 2),
      listener = _deleteInputConnectio4[0],
      isActive = _deleteInputConnectio4[1];

  if (listener !== null) {
    deleteEventListenerOfAudioNode(source, listener);

    if (isActive && !isOffline && !isPartOfACycle(source)) {
      getNativeAudioNode(source).disconnect(getNativeAudioParam(destination), output);
    }
  }
};

var deleteAnyConnection = function deleteAnyConnection(source, isOffline) {
  var audioNodeConnectionsOfSource = getAudioNodeConnections(source);
  var destinations = [];

  var _iterator = _createForOfIteratorHelper(audioNodeConnectionsOfSource.outputs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var outputConnection = _step.value;

      if (isAudioNodeOutputConnection(outputConnection)) {
        deleteInputsOfAudioNode.apply(void 0, [source, isOffline].concat(_toConsumableArray(outputConnection)));
      } else {
        deleteInputsOfAudioParam.apply(void 0, [source, isOffline].concat(_toConsumableArray(outputConnection)));
      }

      destinations.push(outputConnection[0]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  audioNodeConnectionsOfSource.outputs.clear();
  return destinations;
};

var deleteConnectionAtOutput = function deleteConnectionAtOutput(source, isOffline, output) {
  var audioNodeConnectionsOfSource = getAudioNodeConnections(source);
  var destinations = [];

  var _iterator2 = _createForOfIteratorHelper(audioNodeConnectionsOfSource.outputs),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var outputConnection = _step2.value;

      if (outputConnection[1] === output) {
        if (isAudioNodeOutputConnection(outputConnection)) {
          deleteInputsOfAudioNode.apply(void 0, [source, isOffline].concat(_toConsumableArray(outputConnection)));
        } else {
          deleteInputsOfAudioParam.apply(void 0, [source, isOffline].concat(_toConsumableArray(outputConnection)));
        }

        destinations.push(outputConnection[0]);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return destinations;
};

var deleteConnectionToDestination = function deleteConnectionToDestination(source, isOffline, destination, output, input) {
  var audioNodeConnectionsOfSource = getAudioNodeConnections(source);
  return Array.from(audioNodeConnectionsOfSource.outputs).filter(function (outputConnection) {
    return outputConnection[0] === destination && (output === undefined || outputConnection[1] === output) && (input === undefined || outputConnection[2] === input);
  }).map(function (outputConnection) {
    if (isAudioNodeOutputConnection(outputConnection)) {
      deleteInputsOfAudioNode.apply(void 0, [source, isOffline].concat(_toConsumableArray(outputConnection)));
    } else {
      deleteInputsOfAudioParam.apply(void 0, [source, isOffline].concat(_toConsumableArray(outputConnection)));
    }

    audioNodeConnectionsOfSource.outputs.delete(outputConnection);
    return outputConnection[0];
  });
};

export var createAudioNodeConstructor = function createAudioNodeConstructor(addAudioNodeConnections, addConnectionToAudioNode, cacheTestResult, createIncrementCycleCounter, createIndexSizeError, createInvalidAccessError, createNotSupportedError, decrementCycleCounter, detectCycles, eventTargetConstructor, getNativeContext, isNativeAudioContext, isNativeAudioNode, isNativeAudioParam, isNativeOfflineAudioContext) {
  return /*#__PURE__*/function (_eventTargetConstruct) {
    _inherits(AudioNode, _eventTargetConstruct);

    var _super = _createSuper(AudioNode);

    function AudioNode(context, isActive, nativeAudioNode, audioNodeRenderer) {
      var _this;

      _classCallCheck(this, AudioNode);

      _this = _super.call(this, nativeAudioNode);
      _this._context = context;
      _this._nativeAudioNode = nativeAudioNode;
      var nativeContext = getNativeContext(context); // Bug #12: Safari does not support to disconnect a specific destination.

      if (isNativeAudioContext(nativeContext) && true !== cacheTestResult(testAudioNodeDisconnectMethodSupport, function () {
        return testAudioNodeDisconnectMethodSupport(nativeContext);
      })) {
        wrapAudioNodeDisconnectMethod(nativeAudioNode);
      }

      AUDIO_NODE_STORE.set(_assertThisInitialized(_this), nativeAudioNode);
      EVENT_LISTENERS.set(_assertThisInitialized(_this), new Set());

      if (context.state !== 'closed' && isActive) {
        setInternalStateToActive(_assertThisInitialized(_this));
      }

      addAudioNodeConnections(_assertThisInitialized(_this), audioNodeRenderer, nativeAudioNode);
      return _this;
    }

    _createClass(AudioNode, [{
      key: "channelCount",
      get: function get() {
        return this._nativeAudioNode.channelCount;
      },
      set: function set(value) {
        this._nativeAudioNode.channelCount = value;
      }
    }, {
      key: "channelCountMode",
      get: function get() {
        return this._nativeAudioNode.channelCountMode;
      },
      set: function set(value) {
        this._nativeAudioNode.channelCountMode = value;
      }
    }, {
      key: "channelInterpretation",
      get: function get() {
        return this._nativeAudioNode.channelInterpretation;
      },
      set: function set(value) {
        this._nativeAudioNode.channelInterpretation = value;
      }
    }, {
      key: "context",
      get: function get() {
        return this._context;
      }
    }, {
      key: "numberOfInputs",
      get: function get() {
        return this._nativeAudioNode.numberOfInputs;
      }
    }, {
      key: "numberOfOutputs",
      get: function get() {
        return this._nativeAudioNode.numberOfOutputs;
      } // tslint:disable-next-line:invalid-void

    }, {
      key: "connect",
      value: function connect(destination) {
        var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var input = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        // Bug #174: Safari does expose a wrong numberOfOutputs for MediaStreamAudioDestinationNodes.
        if (output < 0 || output >= this._nativeAudioNode.numberOfOutputs) {
          throw createIndexSizeError();
        }

        var nativeContext = getNativeContext(this._context);
        var isOffline = isNativeOfflineAudioContext(nativeContext);

        if (isNativeAudioNode(destination) || isNativeAudioParam(destination)) {
          throw createInvalidAccessError();
        }

        if (isAudioNode(destination)) {
          var nativeDestinationAudioNode = getNativeAudioNode(destination);

          try {
            var connection = connectNativeAudioNodeToNativeAudioNode(this._nativeAudioNode, nativeDestinationAudioNode, output, input);
            var isPassive = isPassiveAudioNode(this);

            if (isOffline || isPassive) {
              var _this$_nativeAudioNod;

              (_this$_nativeAudioNod = this._nativeAudioNode).disconnect.apply(_this$_nativeAudioNod, _toConsumableArray(connection));
            }

            if (this.context.state !== 'closed' && !isPassive && isPassiveAudioNode(destination)) {
              setInternalStateToActive(destination);
            }
          } catch (err) {
            // Bug #41: Safari does not throw the correct exception so far.
            if (err.code === 12) {
              throw createInvalidAccessError();
            }

            throw err;
          }

          var isNewConnectionToAudioNode = addConnectionToAudioNode(this, destination, output, input, isOffline); // Bug #164: Only Firefox detects cycles so far.

          if (isNewConnectionToAudioNode) {
            var cycles = detectCycles([this], destination);
            visitEachAudioNodeOnce(cycles, createIncrementCycleCounter(isOffline));
          }

          return destination;
        }

        var nativeAudioParam = getNativeAudioParam(destination);
        /*
         * Bug #147 & #153: Safari does not support to connect an input signal to the playbackRate AudioParam of an
         * AudioBufferSourceNode. This can't be easily detected and that's why the outdated name property is used here to identify
         * Safari.
         */

        if (nativeAudioParam.name === 'playbackRate') {
          throw createNotSupportedError();
        }

        try {
          this._nativeAudioNode.connect(nativeAudioParam, output);

          if (isOffline || isPassiveAudioNode(this)) {
            this._nativeAudioNode.disconnect(nativeAudioParam, output);
          }
        } catch (err) {
          // Bug #58: Only Firefox does throw an InvalidStateError yet.
          if (err.code === 12) {
            throw createInvalidAccessError();
          }

          throw err;
        }

        var isNewConnectionToAudioParam = addConnectionToAudioParamOfAudioContext(this, destination, output, isOffline); // Bug #164: Only Firefox detects cycles so far.

        if (isNewConnectionToAudioParam) {
          var _cycles = detectCycles([this], destination);

          visitEachAudioNodeOnce(_cycles, createIncrementCycleCounter(isOffline));
        }
      }
    }, {
      key: "disconnect",
      value: function disconnect(destinationOrOutput, output, input) {
        var destinations;
        var nativeContext = getNativeContext(this._context);
        var isOffline = isNativeOfflineAudioContext(nativeContext);

        if (destinationOrOutput === undefined) {
          destinations = deleteAnyConnection(this, isOffline);
        } else if (typeof destinationOrOutput === 'number') {
          if (destinationOrOutput < 0 || destinationOrOutput >= this.numberOfOutputs) {
            throw createIndexSizeError();
          }

          destinations = deleteConnectionAtOutput(this, isOffline, destinationOrOutput);
        } else {
          if (output !== undefined && (output < 0 || output >= this.numberOfOutputs)) {
            throw createIndexSizeError();
          }

          if (isAudioNode(destinationOrOutput) && input !== undefined && (input < 0 || input >= destinationOrOutput.numberOfInputs)) {
            throw createIndexSizeError();
          }

          destinations = deleteConnectionToDestination(this, isOffline, destinationOrOutput, output, input);

          if (destinations.length === 0) {
            throw createInvalidAccessError();
          }
        } // Bug #164: Only Firefox detects cycles so far.


        var _iterator3 = _createForOfIteratorHelper(destinations),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var destination = _step3.value;
            var cycles = detectCycles([this], destination);
            visitEachAudioNodeOnce(cycles, decrementCycleCounter);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }]);

    return AudioNode;
  }(eventTargetConstructor);
};